<app-dialog class="municipality-onboarding-result-modal" [hideClose]="true">
  <ng-container>
    <div class="header-close-wrapper">
      <h4 class="header">
        {{ 'module.modals.onboarding.onboardingModalTitle' | translate }}
      </h4>
      <div class="close-button" (click)="closeModal()">x</div>
    </div>
  </ng-container>

  <div class="municipality-onboarding-result-modal-content-container">
    <ng-container *ngIf="showAdded$ | async">
      <div class="modal-description">
        {{ 'module.modals.onboarding.onboardingResultModalAddedKeysTitle' | translate }}
      </div>
      <div class="modal-keys-title">{{ 'module.modals.onboarding.onboardingModalHeader' | translate }}</div>
      <div class="modal-keys" *ngFor="let keys of onboardingKeys.added">
        <div class="modal-key">
          {{ keys.municipalityKey }}
        </div>
        <div
          matTooltip="{{ 'module.modals.onboarding.onboardingResultModalAddedTooltipLabel' | translate }}"
          [matTooltipPosition]="'above'"
          matTooltipClass="onboarding-tooltip"
          class="modal-key-status modal-status-added"
        >
          <app-svg-icon class="icon" src="./assets/icons/icon_info.svg"></app-svg-icon>
          {{ 'module.modals.onboarding.onboardingResultModalAddedStatusLabel' | translate }}
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="showInvalidSkipped$ | async">
      <div class="modal-description">
        {{ 'module.modals.onboarding.onboardingResultModalInvSkipTitle' | translate }}
      </div>
      <div class="modal-keys-title">{{ 'module.modals.onboarding.onboardingModalHeader' | translate }}</div>
      <div class="modal-keys" *ngFor="let keys of onboardingKeys.skipped">
        <div class="modal-key">
          {{ keys.municipalityKey }}
        </div>
        <div
          matTooltip="{{ 'module.modals.onboarding.onboardingResultModalSkippedTooltipLabel' | translate }}"
          [matTooltipPosition]="'above'"
          matTooltipClass="onboarding-tooltip"
          class="modal-key-status modal-status-skipped"
        >
          <app-svg-icon class="icon" src="./assets/icons/icon_info.svg"></app-svg-icon>
          {{ 'module.modals.onboarding.onboardingResultModalSkippedStatusLabel' | translate }}
        </div>
      </div>
      <div class="modal-keys" *ngFor="let keys of onboardingKeys.invalid">
        <div class="modal-key">
          {{ keys.municipalityKey }}
        </div>
        <div
          matTooltip="{{ 'module.modals.onboarding.onboardingResultModalInvalidTooltipLabel' | translate }}"
          [matTooltipPosition]="'above'"
          matTooltipClass="onboarding-tooltip"
          class="modal-key-status modal-status-invalid"
        >
          <app-svg-icon class="icon" src="./assets/icons/icon_info_danger.svg"></app-svg-icon>
          {{ 'module.modals.onboarding.onboardingResultModalInvalidStatusLabel' | translate }}
        </div>
      </div>
    </ng-container>

    <ng-container>
      <div class="onboarding-actions">
        <button class="btn btn-outline-primary" (click)="closeModal()">
          <span class=""></span>{{ 'module.modals.onboarding.onboardingResultModalOkayButtonLabel' | translate }}
        </button>
      </div>
    </ng-container>
  </div>
</app-dialog>
